import { ChainIdEnum } from "../../../enums/chain";
import { ChainConfig } from "../types";
import {
  DEFAULT_TOKEN_DECIMALS,
  MARGINX_BRANDING,
  getPerpetualDexConfig,
} from "./shared";

// ============================================
// BASECAMP TESTNET (Chain ID: 123420001114)
// ============================================
export const basecampTestnetConfig: ChainConfig = {
  chainId: ChainIdEnum.BASECAMP_TESTNET,
  name: "Basecamp Testnet",
  shortName: "basecamp",
  isTestnet: true,
  rpcUrls: ["https://rpc.basecamp-testnet.org"],
  explorerUrl: "https://basecamp.cloud.blockscout.com",
  l2ExplorerUrl: "https://basecamp.cloud.blockscout.com",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  tokenDecimals: DEFAULT_TOKEN_DECIMALS,
  contracts: {
    erc20: {
      usdc: "0x71002dbf6cC7A885cE6563682932370c056aAca9",
      "usdc-native": "",
      usdt: "0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512",
      weth: "0xDc64a140Aa3E981100a9becA4E685f962f0cF6C9",
      wbtc: "",
      l2usdc: "",
      l2usdt: "0xCf7Ed3AccA5a467e9e704C703E8D87F634fB0Fc9",
      l2weth: "0xDc64a140Aa3E981100a9becA4E685f962f0cF6C9",
      l2wbtc: "0x5FC8d32690cc91D4c39d9d3abcBD16989F875707",
      govToken: "",
    },
    bridge: {
      l1DepositHelper: "0x5FC8d32690cc91D4c39d9d3abcBD16989F875707",
      l1StandardBridge: "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0",
      l2StandardBridge: "0xa513E6E4b8f2a923D98304ec87F64353C4D5C853",
      l2WithdrawProxy: "0x9A676e781A523b5d0C0e43731313A708CB607508",
      exchangePass: "",
      strategies: "",
      staking: "",
    },
    // perpetualDex loaded from deployments/123420001114.json if available
    perpetualDex: getPerpetualDexConfig(ChainIdEnum.BASECAMP_TESTNET, {
      router: "0x12c3534Df9f9782D170DD48C8d6400E6197Ae438",
      crossMargin: "",
      orderHandler: "0x12c3534Df9f9782D170DD48C8d6400E6197Ae438",
      orderVault: "",
      marketFactory: "0x0772000FB1d4ad6BA453339A1bD9888388836C0c",
      usdc: "0x71002dbf6cC7A885cE6563682932370c056aAca9",
      unifiedVault: "0xaDDBDD877E1CcAf94c887224284829552e0c3810",
      unifiedMarginAdapter: "0xF03a6EaFEdBafc72D15c0484B278dc0DbEc567Db",
      positionHandler: "0x498198F4ebC150a9d8013DE06E19E7F9665D9BBa",
      backstopVault: "0x945045aAB59135B262ABbE174B06F4C5B53a8B92",
      oracle: "0x751B80e567324faD2DA489c82211feFE4Fa3B934",
      dataStore: "0x3500f7222A29C19a9b30A6697B43710F54aa9b12",
      marketHandler: "0x286a0800D8e8CFA5f55D8160ef8eCa7223675bD6",
      markets: {
        "BTC-PERP": "0x2Bb0a3517A41F9b9c11c09a5bfE2809Db5668e94",
        "ETH-PERP": "0xc76d34FFe815d23034940df09226637b6Bc9163a",
      },
    }),
  },
  signingDomain: { name: "MarginX Basecamp Testnet", version: "1" },
  branding: MARGINX_BRANDING,
};
